// UI usada pelo ErrorBoundary global e (futuramente) pelos boundaries por feature.
// Mostra erro, oferece retry e (em prod) reporta pro Sentry.
// Em dev mostra stack pra debugar rápido — readme §13.
import type { FallbackProps } from 'react-error-boundary';
import styles from './ErrorFallback.module.css';
import { Button } from '@/components/ui/Button';

export function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <div className={styles.container} role="alert">
      <div className={styles.card}>
        <h1 className={styles.title}>Algo deu errado</h1>
        <p className={styles.message}>{error?.message ?? 'Erro inesperado'}</p>
        {import.meta.env.DEV && error?.stack && <pre className={styles.stack}>{error.stack}</pre>}
        <div className={styles.actions}>
          <Button variant="primary" onClick={resetErrorBoundary}>
            Tentar novamente
          </Button>
          <Button variant="secondary" onClick={() => window.location.assign('/')}>
            Ir para inicio
          </Button>
        </div>
      </div>
    </div>
  );
}
